<template>
  <base-modal
    :reference="'edit_' + booking.id"
    :title="'Editar datos de la reserva'"
    :acceptAction="acceptAction"
    :cancelActionText="'Cerrar'"
  >
    <template v-slot:body>
      <form>
        <div class="d-flex justify-content-center w-100">
          <div class="d-flex flex-column align-items-sm-baseline">
            <label>Hotel</label>
            <v-select
              :options="hotelsList"
              @search="onSearch"
              :reduce="(hotel) => hotel.name"
              label="name"
              v-model="form.hotel"
              style="width: 17vw"
              :disabled="booking.integration == 'wakapos'"
            >
            </v-select>
            <span class="alert alert-info mt-2 text-center" v-if="booking.integration == 'wakapos'">La reserva procede de Waka y por tanto <br> el hotel no se puede modificar</span>
          </div>
        </div>

        <div class="d-flex justify-content-center w-100">
          <div class="d-flex flex-column align-items-sm-baseline">
            <label>Habitación</label>
            <b-form-input
              v-model="form.room"
              placeholder="Inserte número de habitación"
              style="width: 17vw"
            ></b-form-input>
          </div>
        </div>
        <div class="d-flex justify-content-center w-100">
          <div class="d-flex flex-column align-items-sm-baseline">
            <label>Idioma</label>
            <v-select
              :options="languages"
              v-model="form.language"
              :reduce="(language) => language.code"
              style="width: 17vw"
            >
            </v-select>
          </div>
        </div>
        <div class="d-flex justify-content-center w-100">
          <div class="d-flex flex-column align-items-sm-baseline">
            <label>Fecha (día)</label>
            <date-picker v-model="form.day" valueType="YYYY-MM-DD" style="width: 17vw;" :lang="lang"></date-picker>
            <!-- <Datepicker
              :value="form.day"
              @input="updateDate"
              style="mb-2 custom-select" 
              min="2020-01-01"
              max="2036-12-31"
              :dayStr="dayStr"
              :scrollbarProps="{isMobile: false}"
              :placeholder="placeholder"
              :firstDayOfWeek="firstDayOfWeek"
              :monthStr="monthStr"
            ></Datepicker>  -->
          </div>
        </div>
      </form>
    </template>
    
  </base-modal>
</template>

<script>
/* eslint-disable */

import BaseModal from "./BaseModal";
import { mapGetters } from "vuex";
//import {Datepicker} from '@livelybone/vue-datepicker';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';


export default {
  name: "EditBookingModal",
  components: {
    BaseModal,
    DatePicker
  },
  props: {
    booking: {
      type: Object || null,
      required: true,
    },
  },
  data() {
    return {
      form: {
        hotel: this.booking.trekksoft_hotel_name,
        room: this.booking.trekksoft_hotel_room,
        language: this.booking.customer_language,
        day: this.booking.day,
      },
      hotelsList: this.hotels,
      languages: [
        {
          code: "es",
          label: "Español",
        },
        {
          code: "gb",
          label: "Inglés",
        },
        {
          code: "it",
          label: "Italiano",
        },
        {
          code: "fr",
          label: "Francés",
        },
        {
          code: "de",
          label: "Alemán",
        },
        {
          code: "-",
          label: "Otro",
        },
      ],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        }
      }
    };
  },
  async mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      const current = "edit_" + this.booking.id;
      if (modalId == current) {
        this.$store.dispatch("hotels/loadHotels");
        this.form = {
          hotel: this.booking.trekksoft_hotel_name,
          room: this.booking.trekksoft_hotel_room,
          language: this.booking.customer_language,
          day: this.booking.day,
        }
      }
    });
  },
  methods: {
    async acceptAction() {
      // UPDATE bookings table
      const payload = {
        path: this.$route.path,
        reload: true,
        data: this.form,
        booking: this.booking,
      };
      await this.$store.dispatch("bookings/patchBooking", payload);

      this.$bvModal.hide("edit_" + this.booking.id);
      this.$notify({
        group: "foo",
        title: "Reserva editada",
        text: "Se ha editado la información de la reserva",
        type: "success",
      });
    },
    async onSearch(search, loading) {
      await this.$store.dispatch("hotels/loadHotelsSearchByName", search);
      this.hotelsList = this.$store.getters.hotelsByName;
    },
    updateDate(val) {
      this.form.day = val
    },
  },
  computed: {
    ...mapGetters(['hotels'])
  }
};
</script>


<style lang="css" src="@livelybone/vue-datepicker/lib/css/index.css"></style>

<style > 
  .datepicker {
      background: white;
  }
  .datepicker, .datepicker, .timepicker, .datetime-picker {
      height: 30px !important;
  }
  .datepicker .input-wrapper, .datepicker .input-wrapper, .timepicker .input-wrapper, .datetime-picker .input-wrapper {
      border: 1px solid #999 !important;
      border-radius: 0px !important;
  }
  .datepicker .vue-input {
      font-size: 12px !important;
  }
  .datepicker .picker .picker-items .row-item .item.selected::before {
      background: #e7ce28;
      border-radius: 3px;
      border: 1px solid #e7ce28;
  } 
  .datepicker .picker .picker-items .row-item .item.is-now::before {
      border: 1px solid #e7ce28;
  }
  .datepicker .picker .picker-items .row-item .item.is-now {
    color: black;
    font-weight: bold;
  }
  .datepicker .picker .picker-items .row-item .item.selected {
    color: black;
  }
</style>